import React from 'react'
import axios from "../../../utils/fvAxios";
import { useEffect, useState } from "react";
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

export default function PreqAnalytics({Alignments}) {
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
 
    const [alignment, setAlignment] = React.useState("");
    const [refresh, setRefresh] = useState(false); 
    const [details, setDetails] = useState([]);
    const [token, setToken] = useState("");
  
  
  
    useEffect(() => {
      if(Alignments){
      axios.get("Prequalification/GetExternalPowerBIReportDetails?reportID="+Alignments
      ).then((res) => {
        if (res?.data?.responseCode === 100) {
            setDetails(res?.data?.data?.value?.embedReports);
            setToken(res?.data?.data?.value?.embedToken?.token);
        }
        else {
          setError(res.data.responseMessage);
        }
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        setIsLoading(false);
      });
    }else{}
    }, [Alignments]);
    


  return (
   <>
    {/* <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop> */}
     {details?.map((r, index) =>
        <PowerBIEmbed
        style={{marginTop:"none",height:"100%"}}
          key={index}
          embedConfig={{
            type: 'report',
            id: r.reportId,
            embedUrl: r.embedUrl,
            accessToken: token,
            tokenType: models.TokenType.Embed,
            settings: {
              panes: {
                filters: {
                  expanded: false,
                  visible: false
                },
                bars: {
                  statusBar: {
                      visible: false
                  }
              }
        
              },
            }
          }}

          eventHandlers={
            new Map([
              ['loaded', function () { console.log('Report loaded'); }],
              ['rendered', function () { console.log('Report rendered'); }],
              ['error', function (event) { console.log(event.detail); }]
            ])
          }

          cssClassName={"embed_container"}
          

          getEmbeddedComponent={(embeddedReport) => {
            window.report = embeddedReport;
          }}
        />
      )}
   </>
  )
}
